export interface CookieConsentRequest {
  cookie_name: 'strictly_necessary' | 'performance' | 'targeting';
  cookie_version: 'string';
  accepted: boolean;
  expires?: string;
  user_action: 'accept_all' | 'reject_all' | 'customize' | 'no_sell';
}
